import { useEffect } from "react"
import { usePage } from "@inertiajs/react"
import toast, { Toaster as HotToaster } from "react-hot-toast"

const typeMap = {
  notice: "success",
  alert: "error",
} as const

const Toaster = () => {
  const { flash } = usePage().props

  useEffect(() => {
    Object.entries(flash).forEach(([type, message]) => {
      if (type in typeMap && message) {
        toast[typeMap[type as keyof typeof typeMap]](message)
      }
    })
  }, [flash])

  return (
    <HotToaster
      toastOptions={{
        duration: 4000,
      }}
    />
  )
}
export default Toaster
